var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.218 5.26a1.19 1.19 0 0 0 .35-.846c0-.32-.124-.62-.35-.846l-.95-.95a1.19 1.19 0 0 0-.846-.35c-.32 0-.62.124-.846.35L3.21 8.963v2.643h2.642l6.365-6.345zm-1.796-1.795.95.949-.952.948-.95-.949.952-.948zm-6.014 6.944v-.95l4.215-4.2.95.949-4.215 4.2h-.95zm-1.197 2.394h9.578v1.198H3.211v-1.198z",
    fill: "#323234"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditSmall);
export default __webpack_public_path__ + "static/media/edit-small.d170cbafbc1af157c7d20d34ad9d4e11.svg";
export { ForwardRef as ReactComponent };